//#region deposit Crypto
export enum ERequestStatusCryptoType {
    New = 1, //جدید
    Pending = 2, // در انتظار
    Processing = 3, //درحال پردازش
    Sending = 4, //در حال ارسال
    AwatingApproval = 5, //در انتظار تأیید
    Broadcast = 6, //درحال پردازش
    Paying = 7, //درحال پرداخت
    Done = 10, // تایید شده
}

export enum ERequestStatusCryptoTextType {
    New = 'New', //جدید
    Pending = 'Pending', // در انتظار
    Processing = 'Processing', //درحال پردازش
    Done = 'Done', // تایید شده
}


export namespace ERequestStatusCryptoType {

    export function getTitle(type: ERequestStatusCryptoType): string {
        return Object.keys(ERequestStatusCryptoType).find(key => ERequestStatusCryptoType[key] === type);
    }

}

export namespace ERequestStatusCryptoTextType {

    export function getTitle(type: ERequestStatusCryptoTextType): string {
        return Object.keys(ERequestStatusCryptoTextType).find(key => ERequestStatusCryptoTextType[key] === type);
    }

}

//#endregion



//#region withdraw Crypto

export enum ERequestStatusCryptoWithdrawType {
    New = 1, //جدید
    Processing = 2, //درحال پردازش
    AwatingApproval = 3, //در انتظار تأیید
    Canceled = 4, //لغو شده 
    Failure = 5, // ناموفق
    Scheduled = 6, //درحال پردازش
    Done = 10, // تایید شده
    Exception = 20, // ناموفق
}


export enum ERequestStatusCryptoWithdrawTextType {
    New = 'New', //جدید
    Processing = 'Processing', //درحال پردازش
    AwatingApproval = 'AwatingApproval', //در انتظار تأیید
    Canceled = 'Canceled', //لغو شده 
    Failure = 'Failure', // ناموفق
    Scheduled = 'Scheduled',  //درحال پردازش
    Done = 'Done', // تایید شده
    Exception = 'Exception', // ناموفق
}


export namespace ERequestStatusCryptoWithdrawType {
    export function getTitle(type: ERequestStatusCryptoWithdrawType): string {
        return Object.keys(ERequestStatusCryptoWithdrawType).find(key => ERequestStatusCryptoWithdrawType[key] === type);
    }
}

export namespace ERequestStatusCryptoWithdrawTextType {
    export function getTitle(type: ERequestStatusCryptoWithdrawTextType): string {
        return Object.keys(ERequestStatusCryptoWithdrawTextType).find(key => ERequestStatusCryptoWithdrawTextType[key] === type);
    }
}

//#endregion
